import React, {useEffect, useState, useCallback} from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {SchoolService} from './SchoolService';
import {SchoolsConnection} from '../../graphql/API';
import {TablePaginationConfig} from 'antd/es/table';

// TODO: SchoolsTableUI doesn't exist in new DSM - needs to be rebuilt with atomic components
// Temporary stub component
const SchoolsTableUI: React.FC<any> = (props) => {
  return (
    <div className="p-4 bg-yellow-50 border border-yellow-200 rounded">
      <p className="text-gray-700 font-semibold mb-2">⚠️ SchoolsTable needs migration</p>
      <p className="text-sm text-gray-500">This component needs to be rebuilt using atomic design components from the new DSM.</p>
    </div>
  );
};

const schoolService = new SchoolService();

export const SchoolsTable: React.FC = () => {
  const [schools, setSchools] = useState<SchoolsConnection | undefined>(
    undefined,
  );
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [current, setCurrent] = useState<number>(1);
  const [maxNumReachedPages, setMaxNumReachedPages] = useState<number>(1);

  useEffect(() => {
    schoolService
      .getSchools(schools?.nextToken)
      .then((resp: SchoolsConnection) => {
        const currentItems = schools?.items ?? [];
        setSchools({
          ...schools,
          ...resp,
          items: [...currentItems, ...resp.items],
        });
        setIsLoading(false);
      })
      .catch((error) => {
        setIsError(true);
        console.error('getSchools Error:', error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Updated onChange callback to use TablePaginationConfig which may have current undefined.
  const onChangeLogic = useCallback(
    (
      pagination: TablePaginationConfig,
      filters: any,
      sorter: any,
      extra: any,
    ) => {
      // Use nullish coalescing (??) to convert undefined to 0 (or any default number if needed)
      const currentPage = pagination.current ?? 0;
      if (currentPage >= maxNumReachedPages) {
        setCurrent(currentPage);
        setMaxNumReachedPages(currentPage);
      }
    },
    [maxNumReachedPages],
  );

  // Define a date formatter function that uses moment
  const formatDate = (date: string) => moment(date).format('YYYY-MM-DD');

  return (
    <SchoolsTableUI
      items={schools?.items || []}
      current={current}
      onChange={onChangeLogic}
      isLoading={isLoading}
      isError={isError}
      LinkComponent={Link}
      formatDate={formatDate}
    />
  );
};
